import { createBrowserRouter } from 'react-router-dom';
import { routes } from './routes.tsx';
import { withFaroRouterInstrumentation } from '../utils/monitoring/faro';
import { App } from '@capacitor/app';
import { useEffect } from 'react';

// Declare Capacitor types for TypeScript
declare global {
  interface Window {
    Capacitor?: {
      isNativePlatform: () => boolean;
    };
  }
}

// Create the router with your routes
// Note: We're not setting scroll behavior here as it's handled by our useScrollToTop hook
const reactBrowserRouter = createBrowserRouter(routes);

// Wrap the router with Faro instrumentation
export const router = withFaroRouterInstrumentation(reactBrowserRouter);

// Custom hook to handle back button in Capacitor apps
export const useCapacitorBackButton = () => {
  useEffect(() => {
    // Only add the listener if we're running in a Capacitor app
    if (window.Capacitor?.isNativePlatform()) {
      const handleBackButton = () => {
        // If we can go back in the history, do that instead of exiting
        if (window.history.length > 1) {
          window.history.back();
          return { shouldOverrideUrlLoading: true };
        }
        // Otherwise, let the default behavior happen (exit the app)
        return { shouldOverrideUrlLoading: false };
      };

      // Register the back button handler
      App.addListener('backButton', handleBackButton);

      // Clean up the listener when the component unmounts
      return () => {
        App.removeAllListeners();
      };
    }
  }, []);
}; 